import {fromJS} from 'immutable'

export default (groupChats = fromJS({}), groupChatOrders = fromJS({})) => {
  groupChatOrders = groupChatOrders === null ? fromJS({}) : groupChatOrders

  return groupChats
    .map((gc, key) => gc.set('key', key))
    .map((gc, key) => gc.set('order', groupChatOrders.get(key)))
    .toList()
    .sortBy((gc) => gc.get('order'))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/order_group_chats.js
 **/